// extracted by mini-css-extract-plugin
export default {"wrapper":"skills_wrapper__uaohv","title":"skills_title__tlnPo"};